"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useSwitchChecked_1 = require("./hooks/useSwitchChecked");
const Switch_module_scss_1 = __importDefault(require("./Switch.module.scss"));
const Switch = ({ id, name, value, role, disabled, ariaLabel, ariaLabelledBy, checked, inputClassName, onChange, ariaControls, defaultChecked, children: originalChildren, wrapperClassName }) => {
    const ref = (0, react_1.useRef)();
    const { onChange: overrideOnChange, checked: overrideChecked } = (0, useSwitchChecked_1.useSwitchChecked)({
        checked,
        defaultChecked,
        onChange
    });
    const children = (0, react_1.useMemo)(() => react_1.default.cloneElement(originalChildren, Object.assign(Object.assign({}, originalChildren === null || originalChildren === void 0 ? void 0 : originalChildren.props), { checked: overrideChecked })), [originalChildren, overrideChecked]);
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({ htmlFor: id, className: wrapperClassName }, { children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, id: id, "aria-controls": ariaControls, value: value, name: name, type: "checkbox", className: (0, classnames_1.default)(Switch_module_scss_1.default["hidden-switch"], inputClassName), checked: overrideChecked, role: role ? role : "switch", onChange: overrideOnChange, disabled: disabled, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-checked": overrideChecked }), children] })));
};
exports.Switch = Switch;
